import { Link } from "react-router-dom";

const PHONE_DISPLAY = "01 84 80 46 86";
const PHONE_TEL = "tel:+33184804686";

// External authoritative resources for E-E-A-T (visible on all 401 pages).
// Kept compact: icon + 1-3 word label only. Long labels removed to reduce
// repeated-content dilution flagged by SEO crawlers.
const OFFICIAL_LINKS = [
    { href: "https://www.service-public.fr/particuliers/vosdroits/F11094", icon: "fa-landmark", label: "Service-Public.fr", testid: "footer-ext-service-public" },
    { href: "https://www.ecologie.gouv.fr/indice-reparabilite", icon: "fa-leaf", label: "Min. Écologie", testid: "footer-ext-ecologie" },
    { href: "https://www.ademe.fr/particuliers-eco-citoyens/maison/electromenager-multimedia/", icon: "fa-bolt", label: "ADEME", testid: "footer-ext-ademe" },
    { href: "https://www.ecosystem.eco/fr/article/bonus-reparation", icon: "fa-screwdriver-wrench", label: "Ecosystem", testid: "footer-ext-ecosystem" },
    { href: "https://www.qualirepar.fr/annuaire", icon: "fa-certificate", label: "QualiRépar", testid: "footer-ext-qualirepar" },
    { href: "https://signal.conso.gouv.fr/", icon: "fa-shield-halved", label: "SignalConso", testid: "footer-ext-signalconso" },
];

function BrandContact() {
    return (
        <div className="max-w-7xl mx-auto px-5 lg:px-10 py-10 grid md:grid-cols-3 gap-8 items-start">
            <div className="flex items-center gap-2.5">
                <span className="w-9 h-9 rounded-xl bg-[var(--amber)] grid place-items-center text-[var(--navy)] font-extrabold text-lg">E</span>
                <span className="heading text-lg font-extrabold tracking-tight text-[var(--cream)]">Electrocase</span>
            </div>
            <ul className="space-y-1 text-sm">
                <li><a className="hover:text-[var(--amber)]" href={PHONE_TEL} data-testid="footer-phone"><i className="fa-solid fa-phone mr-2" />{PHONE_DISPLAY}</a></li>
                <li><a className="hover:text-[var(--amber)]" href="mailto:postmaster@electrocase.fr" data-testid="footer-email"><i className="fa-solid fa-envelope mr-2" />postmaster@electrocase.fr</a></li>
                <li className="text-[var(--cream)]/70 text-xs"><i className="fa-regular fa-clock mr-2" />Lun–Sam 08 h – 20 h</li>
            </ul>
            <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs justify-start md:justify-end text-[var(--cream)]/80">
                <li><Link className="hover:text-[var(--amber)]" to="/mentions-legales">Mentions légales</Link></li>
                <li><Link className="hover:text-[var(--amber)]" to="/a-propos">À propos</Link></li>
                <li><Link className="hover:text-[var(--amber)]" to="/notre-methodologie">Méthodologie</Link></li>
                <li><Link className="hover:text-[var(--amber)]" to="/codes-erreur" data-testid="footer-codes-erreur">Codes erreur</Link></li>
                <li><Link className="hover:text-[var(--amber)]" to="/carte-interventions-idf" data-testid="footer-carte">Carte interventions</Link></li>
                <li><Link className="hover:text-[var(--amber)]" to="/plan-du-site">Plan du site</Link></li>
            </ul>
        </div>
    );
}

function OfficialResources() {
    return (
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-5">
                <ul className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-[var(--cream)]/80 items-center">
                    <li className="text-[10px] uppercase tracking-widest text-[var(--amber)] font-bold">Ressources officielles</li>
                    {OFFICIAL_LINKS.map((l) => (
                        <li key={l.href}>
                            <a href={l.href} target="_blank" rel="noopener noreferrer external" className="hover:text-[var(--amber)] inline-flex items-center gap-1.5" data-testid={l.testid}>
                                <i className={`fa-solid ${l.icon} text-[var(--amber)]/80`} />
                                {l.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

function BottomBar() {
    return (
        <div className="border-t border-white/10">
            <div className="max-w-7xl mx-auto px-5 lg:px-10 py-4 flex flex-col md:flex-row items-center justify-between gap-1 text-xs text-[var(--cream)]/70">
                <p>© {new Date().getFullYear()} Electrocase · Tous droits réservés.</p>
                <p>SIRET ●●● ●●● ●●● ●●●●●</p>
            </div>
        </div>
    );
}

export default function Footer() {
    return (
        <footer className="bg-[var(--navy)] text-[var(--cream)] mt-24">
            <BrandContact />
            <OfficialResources />
            <BottomBar />
        </footer>
    );
}
